import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React from 'react';
import { View, TouchableOpacity, Text } from 'react-native';
import { CustomStyleSheet } from '../../../utils/rn/tools';
import { useTracking } from '../../../hooks/rn/useTracking';
import CheckboxInner from '../../../assets/images/rn/CheckboxInner';
import CheckMark from '../../../assets/images/rn/CheckMark';
export var RadioButton = function RadioButton(props) {
  var label = props.label,
    _props$checked = props.checked,
    checked = _props$checked === void 0 ? false : _props$checked,
    onClick = props.onClick,
    disabled = props.disabled,
    textStyle = props.textStyle,
    containerStyle = props.containerStyle,
    _props$isButtonRight = props.isButtonRight,
    isButtonRight = _props$isButtonRight === void 0 ? false : _props$isButtonRight,
    customBtnElement = props.customBtnElement,
    _props$isCheckbox = props.isCheckbox,
    isCheckbox = _props$isCheckbox === void 0 ? false : _props$isCheckbox,
    _props$isCheckMark = props.isCheckMark,
    isCheckMark = _props$isCheckMark === void 0 ? false : _props$isCheckMark,
    checkboxStyle = props.checkboxStyle,
    radioStyle = props.radioStyle;
  var _useTracking = useTracking(props),
    tracker = _useTracking.tracker,
    trackingClick = _useTracking.trackingClick,
    trackingImpressionProps = _useTracking.trackingImpressionProps;
  var onPress = function onPress(e) {
    var _props$trackingData, _props$trackingData$t;
    trackingClick && tracker.click(_objectSpread(_objectSpread({}, trackingClick), {}, {
      data: _objectSpread(_objectSpread(_objectSpread({}, (trackingClick === null || trackingClick === void 0 ? void 0 : trackingClick.data) || {}), (_props$trackingData = props.trackingData) === null || _props$trackingData === void 0 ? void 0 : (_props$trackingData$t = _props$trackingData.trackingdataClick) === null || _props$trackingData$t === void 0 ? void 0 : _props$trackingData$t.call(_props$trackingData, _objectSpread(_objectSpread({}, props.componentData || {}), {}, {
        disabled: disabled
      }))), {}, {
        is_dropped: 1 // 用于 case creation webform 需求
      })
    }));

    if (disabled) {
      return;
    }
    onClick === null || onClick === void 0 ? void 0 : onClick(e);
  };
  return /*#__PURE__*/React.createElement(TouchableOpacity, _extends({
    style: [styles.radioButton, containerStyle],
    onPress: onPress
  }, trackingImpressionProps), isButtonRight && (customBtnElement ? /*#__PURE__*/React.createElement(View, {
    style: styles.customBtnElementStyle
  }, customBtnElement) : /*#__PURE__*/React.createElement(Text, {
    style: [styles.text, styles.leftText, textStyle]
  }, label)), isCheckbox ? /*#__PURE__*/React.createElement(View, {
    style: [styles.checkbox, checked && styles.checkboxSelected, disabled && styles.disabled, checkboxStyle]
  }, /*#__PURE__*/React.createElement(View, {
    style: checked ? styles.checkboxInner : styles.hide
  }, /*#__PURE__*/React.createElement(CheckboxInner, null))) : isCheckMark ? /*#__PURE__*/React.createElement(View, {
    style: checked ? styles.checkmark : styles.hide
  }, /*#__PURE__*/React.createElement(CheckMark, null)) : /*#__PURE__*/React.createElement(View, {
    style: [styles.radio, checked && styles.radioSelected, disabled && styles.disabled, radioStyle]
  }, /*#__PURE__*/React.createElement(View, {
    style: checked ? styles.radioInner : styles.hide
  })), !isButtonRight && (customBtnElement ? /*#__PURE__*/React.createElement(View, {
    style: styles.customBtnElementStyle
  }, customBtnElement) : /*#__PURE__*/React.createElement(Text, {
    style: [styles.text, textStyle]
  }, label)));
};
var styles = CustomStyleSheet({
  radioButton: {
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 5
  },
  disabled: {
    borderColor: 'rgba(0, 0, 0, 0.26)',
    borderWidth: 1,
    backgroundColor: '#f5f5f5'
  },
  radio: {
    width: 20,
    height: 20,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: 'rgba(0, 0, 0, 0.54)',
    marginRight: 12
  },
  radioSelected: {
    borderColor: '#ee4d2d',
    borderWidth: 2
  },
  hide: {
    display: 'none'
  },
  radioInner: {
    width: 8,
    height: 8,
    borderRadius: 4,
    marginTop: 4,
    marginLeft: 4,
    backgroundColor: '#ee4d2d'
  },
  checkbox: {
    width: 20,
    height: 20,
    borderRadius: 2,
    borderWidth: 1,
    borderColor: 'rgba(0, 0, 0, 0.54)',
    marginRight: 12
  },
  checkboxSelected: {
    borderWidth: 0
  },
  checkboxInner: {
    width: 20,
    height: 20,
    borderRadius: 2,
    borderWidth: 0,
    backgroundColor: '#ee4d2d',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center'
  },
  checkmark: {
    width: 24,
    height: 24
  },
  text: {
    fontSize: 14,
    lineHeight: 24,
    color: 'rgba(0,0,0,.87)'
  },
  leftText: {
    flex: 1
  },
  customBtnElementStyle: {
    flex: 1
  }
});